import {
  login,
  LoginData,
  Verify,
  verify,
  Email,
  email,
  Repeat,
  repeat,
  UserReset,
  userReset,
  userInfo,
  Agreement,
  agreement,
  confirm,
  getMenuList,
  VerifyPassword,
  verifyPassword,
  getAuthTime,
  getLogo,
  logout,
  getExistRecord,
  postIsRecord,
  getUnreadNotifyList,
  putBatchReadNotify,
  putReadNotify,
  subLogin,
  userSubInfo,
  getAuthStatus,
  confirmPassword,
  fixPassword,
  FixPwd,
  ConfirmPwd,
  passwordLength,
  emailCode,
  Emailcode,
} from '@/api/login'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'

export const useLogin = () => {
  const { runAsync, loading } = useRequest((data: LoginData) => login(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '登录失败')
    },
  })

  return [runAsync, loading] as const
}
export const useVerify = () => {
  const { runAsync } = useRequest((data: Verify) => verify(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取验证码失败')
    },
  })

  return [runAsync] as const
}
export const useEmail = () => {
  const { runAsync: run } = useRequest((data: Email) => email(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '发送重置邮件失败')
    },
  })

  return [run] as const
}
export const useEmailVerify = () => {
  const { runAsync: run } = useRequest((data: Emailcode) => emailCode(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '发送邮件验证码失败')
    },
  })

  return [run] as const
}
export const useRepeat = () => {
  const { runAsync: run } = useRequest((data: Repeat) => repeat(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '发送重置邮件失败')
    },
  })

  return [run] as const
}
export const useUserReset = () => {
  const { runAsync: run } = useRequest((data: UserReset) => userReset(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '发送重置邮件失败')
    },
  })

  return [run] as const
}
export const useUserInfo = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest(userInfo, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '个人信息获取失败')
    },
  })
  return [data?.data || null, run, loading] as const
}
export const useUserSubInfo = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest(userSubInfo, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '个人信息获取失败')
    },
  })
  return [data?.data || null, run, loading] as const
}

export const usePasswordLength = () => {
  const { runAsync: run } = useRequest(passwordLength, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '密码配置获取失败')
    },
  })
  return [run] as const
}

export const useAgreement = () => {
  const { runAsync: run } = useRequest((data: Agreement) => agreement(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取用户协议失败')
    },
  })
  return [run] as const
}

export const useConfirm = () => {
  const { runAsync: run } = useRequest(confirm, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '个人信息获取失败')
    },
  })
  return [run] as const
}

export const useGetMenuList = () => {
  const { runAsync: run, data } = useRequest(getMenuList, {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取权限列表失败')
    },
  })
  return [run, data?.data || []] as const
}
// 获取授权时间
export const useGetAuthTime = () => {
  const { runAsync: run, data } = useRequest(() => getAuthTime(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取授权时间失败')
    },
  })
  return [run, data?.data || []] as const
}

// 获取密码位数
export const useGetLoginConfig = () => {
  const { runAsync: run, data } = useRequest(() => getAuthTime(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取登录配置信息失败')
    },
  })
  return [run, data?.data || []] as const
}

// 校验密码
export const useVerifyPassword = () => {
  const { runAsync: run } = useRequest((data: VerifyPassword) => verifyPassword(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '密码错误')
    },
  })
  return [run] as const
}
// 获取logo
export const useGetLogo = () => {
  const { runAsync: run, data } = useRequest(() => getLogo(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取logo错误')
    },
  })
  return [run, data?.data] as const
}
//获取授权
export const useGetAuthStatus = () => {
  const { data, runAsync: run } = useRequest(() => getAuthStatus(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取权限时间错误')
    },
  })
  return [data?.data, run] as const
}
// 退出登录
export const useLogout = () => {
  const { runAsync: run } = useRequest(data => logout(data), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '获取logo错误')
    },
  })
  return [run] as const
}
// 首页提示
export const useGetExistRecord = () => {
  const { runAsync: run, data } = useRequest(() => getExistRecord(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取失败')
    },
  })
  return [run, data?.data || {}] as const
}
// 首页推送确认已读
export const usePostIsRecord = () => {
  const { runAsync: run, data } = useRequest((datas: { id: string }) => postIsRecord(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '操作失败')
    },
  })
  return [run, data?.data || {}] as const
}
export const useGetUnreadNotifyList = () => {
  const { runAsync: run, data } = useRequest(() => getUnreadNotifyList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取失败')
    },
  })
  return [run, data] as const
}
export const usePutBatchReadNotify = () => {
  const { runAsync: run } = useRequest(() => putBatchReadNotify(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '操作失败')
    },
  })
  return [run] as const
}
export const usePutReadNotify = () => {
  const { runAsync: run } = useRequest((data: { id: string }) => putReadNotify(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取失败')
    },
  })
  return [run] as const
}
export const useSubLogin = () => {
  const { runAsync, loading } = useRequest((data: LoginData) => subLogin(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '登录失败')
    },
  })

  return [runAsync, loading] as const
}

//验证密码
export const setConfirmPassword = () => {
  const { runAsync, loading } = useRequest((data: ConfirmPwd) => confirmPassword(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '验证密码失败')
    },
  })

  return [runAsync, loading] as const
}

//确认密码
export const setFixPassword = () => {
  const { runAsync, loading } = useRequest((data: FixPwd) => fixPassword(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '确认密码失败')
    },
  })

  return [runAsync, loading] as const
}
